module.exports = __webpack_public_path__ + "static/media/29ADMSPC32.98da45a2.jpg";